import { render, staticRenderFns } from "./CreateEmailModal.vue?vue&type=template&id=66b32eda&scoped=true"
import script from "./CreateEmailModal.vue?vue&type=script&lang=js"
export * from "./CreateEmailModal.vue?vue&type=script&lang=js"
import style0 from "./CreateEmailModal.vue?vue&type=style&index=0&id=66b32eda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b32eda",
  null
  
)

export default component.exports